"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HttpConnection = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _events = require("events");

var _crossFetch = _interopRequireDefault(require("cross-fetch"));

var _safeJson = require("@walletconnect/safe-json");

var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var DEFAULT_HTTP_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
var DEFAULT_HTTP_METHOD = "POST";
var DEFAULT_FETCH_OPTS = {
  headers: DEFAULT_HTTP_HEADERS,
  method: DEFAULT_HTTP_METHOD
};
var EVENT_EMITTER_MAX_LISTENERS_DEFAULT = 10;

var HttpConnection = /*#__PURE__*/function () {
  function HttpConnection(url) {
    var disableProviderPing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, HttpConnection);

    this.url = url;
    this.disableProviderPing = disableProviderPing;
    this.events = new _events.EventEmitter();
    this.isAvailable = false;
    this.registering = false;

    if (!(0, _jsonrpcUtils.isHttpUrl)(url)) {
      throw new Error("Provided URL is not compatible with HTTP connection: ".concat(url));
    }

    this.url = url;
    this.disableProviderPing = disableProviderPing;
  }

  _createClass(HttpConnection, [{
    key: "connected",
    get: function get() {
      return this.isAvailable;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.registering;
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var url,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.url;
                _context.next = 3;
                return this.register(url);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isAvailable) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Connection already closed");

              case 2:
                this.onClose();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(payload, context) {
        var body, res, data;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.isAvailable) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.register();

              case 3:
                _context3.prev = 3;
                body = (0, _safeJson.safeJsonStringify)(payload);
                _context3.next = 7;
                return (0, _crossFetch["default"])(this.url, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), {
                  body: body
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 10;
                return res.json();

              case 10:
                data = _context3.sent;
                this.onPayload({
                  data: data
                });
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](3);
                this.onError(payload.id, _context3.t0);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 14]]);
      }));

      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var _this = this;

        var url,
            currentMaxListeners,
            body,
            error,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : this.url;

                if ((0, _jsonrpcUtils.isHttpUrl)(url)) {
                  _context4.next = 3;
                  break;
                }

                throw new Error("Provided URL is not compatible with HTTP connection: ".concat(url));

              case 3:
                if (!this.registering) {
                  _context4.next = 7;
                  break;
                }

                currentMaxListeners = this.events.getMaxListeners();

                if (this.events.listenerCount("register_error") >= currentMaxListeners || this.events.listenerCount("open") >= currentMaxListeners) {
                  this.events.setMaxListeners(currentMaxListeners + 1);
                }

                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  _this.events.once("register_error", function (error) {
                    _this.resetMaxListeners();

                    reject(error);
                  });

                  _this.events.once("open", function () {
                    _this.resetMaxListeners();

                    if (typeof _this.isAvailable === "undefined") {
                      return reject(new Error("HTTP connection is missing or invalid"));
                    }

                    resolve();
                  });
                }));

              case 7:
                this.url = url;
                this.registering = true;
                _context4.prev = 9;

                if (this.disableProviderPing) {
                  _context4.next = 14;
                  break;
                }

                body = (0, _safeJson.safeJsonStringify)({
                  id: 1,
                  jsonrpc: "2.0",
                  method: "test",
                  params: []
                });
                _context4.next = 14;
                return (0, _crossFetch["default"])(url, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), {
                  body: body
                }));

              case 14:
                this.onOpen();
                _context4.next = 23;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](9);
                error = this.parseError(_context4.t0);
                this.events.emit("register_error", error);
                this.onClose();
                throw error;

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 17]]);
      }));

      function register() {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "onOpen",
    value: function onOpen() {
      this.isAvailable = true;
      this.registering = false;
      this.events.emit("open");
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.isAvailable = false;
      this.registering = false;
      this.events.emit("close");
    }
  }, {
    key: "onPayload",
    value: function onPayload(e) {
      if (typeof e.data === "undefined") return;
      var payload = typeof e.data === "string" ? (0, _safeJson.safeJsonParse)(e.data) : e.data;
      this.events.emit("payload", payload);
    }
  }, {
    key: "onError",
    value: function onError(id, e) {
      var error = this.parseError(e);
      var message = error.message || error.toString();
      var payload = (0, _jsonrpcUtils.formatJsonRpcError)(id, message);
      this.events.emit("payload", payload);
    }
  }, {
    key: "parseError",
    value: function parseError(e) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.url;
      return (0, _jsonrpcUtils.parseConnectionError)(e, url, "HTTP");
    }
  }, {
    key: "resetMaxListeners",
    value: function resetMaxListeners() {
      if (this.events.getMaxListeners() > EVENT_EMITTER_MAX_LISTENERS_DEFAULT) {
        this.events.setMaxListeners(EVENT_EMITTER_MAX_LISTENERS_DEFAULT);
      }
    }
  }]);

  return HttpConnection;
}();

exports.HttpConnection = HttpConnection;
var _default = HttpConnection;
exports["default"] = _default;